import React from 'react';
import PropTypes from 'prop-types';
import {List} from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {unparse} from 'papaparse';
import moment from 'moment-timezone';
import download from 'downloadjs';

import {Button, Icon} from '@albert-io/atomic';

import sanitize from 'lib/sanitize';

import {getModelForResourceType} from 'resources/modelRegistry';

const CreateAccountsResultsSummary = ({archivedInvalidEntries, school, validEntries}) => {
  const handleClick = () => {
    const accepted = validEntries
      .sortBy((item) => item.get('lastName').toLowerCase())
      .reduce((prev, curr) => {
        const row = [
          curr.get('lastName'),
          curr.get('firstName'),
          curr.get('email'),
          curr.get('username'),
          ' ',
          'success',
          ' '
        ];
        prev.push(row);
        return prev;
      }, []);

    /** Sort invalid entries between accounts for which an email was found and otherwise erroneous */
    const [rejected, matchingEmailFound] = archivedInvalidEntries.reduce(
      // eslint-disable-next-line no-shadow
      ([rejected, matchingEmailFound], curr) => {
        return curr.get('error') === 'nonUniqueEmail'
          ? [rejected, matchingEmailFound.push(curr)]
          : [rejected.push(curr), matchingEmailFound];
      },
      [List(), List()]
    );

    const sortedRejects = rejected
      .sortBy((item) => item.get('lastName').toLowerCase())
      .reduce((prev, curr) => {
        const row = [
          curr.get('lastName'),
          curr.get('firstName'),
          curr.get('email'),
          curr.get('username'),
          ' ',
          'error',
          curr.get('errorMessage')
        ];
        prev.push(row);
        return prev;
      }, []);

    const sortedMatches = matchingEmailFound
      .sortBy((item) => item.get('lastName').toLowerCase())
      .reduce((prev, curr) => {
        const row = [
          curr.get('lastName'),
          curr.get('firstName'),
          curr.get('email'),
          curr.get('username'),
          ' ',
          'N/A',
          curr.get('errorMessage')
        ];
        prev.push(row);
        return prev;
      }, []);
    const csv = unparse({
      fields: ['lastName', 'firstName', 'email', 'username', 'password', 'status', 'reason'],
      data: [...accepted, ...sortedRejects, ...sortedMatches]
    });

    const schoolName = sanitize.filename(school.getName());
    download(
      csv,
      `Student Accounts ${moment().format('YYYY-MM-DD HH mm')} ${schoolName} Albert.csv`,
      'text/csv'
    );
  };

  return (
    <Button className='u-mar-b_1 u-width_100pc' onClick={handleClick}>
      <Icon color='white' className='u-mar-r_2' icon='download' />
      Download summary (.csv)
    </Button>
  );
};

CreateAccountsResultsSummary.propTypes = {
  archivedInvalidEntries: ImmutablePropTypes.set.isRequired,
  school: PropTypes.instanceOf(getModelForResourceType('school_v5')).isRequired,
  validEntries: ImmutablePropTypes.list.isRequired
};

export default CreateAccountsResultsSummary;
